<template>
  <div class="side-help-tooltips"
       :class="selector">
    <transition name="group-fade">
      <HelpFloat v-if="isFixed"
                 :title="$tMyVacancyHint('hint_1_title')"
                 @toggle-tooltip="onToggle"/>
    </transition>
    <div class="side-help-tooltips__wrap">
      <template v-if="isFixed">
        <button type="button" class="side-help-tooltips__close" @click.prevent="onToggle">
          <span class="side-help-tooltips__close-text">{{ $tMyVacancyHint('Back to my vacancies') }}</span>
          <span class="side-help-tooltips__close-ico">
            <BaseSvg name="ico-close"/>
          </span>
        </button>
      </template>
      <transition name="group-fade">
        <HelpTooltip :title="$tMyVacancyHint('hint_1_title')"
                     :description="$tMyVacancyHint('hint_1_description')"
                     :src="img1"
                     class="side-help-tooltips__inner"/>
      </transition>
    </div>
  </div>
</template>

<script>
import {blockScroll, unBlockScroll} from '@/helpers/scroll'
import HelpTooltip from '../HelpTooltip'
import HelpFloat from '../HelpTooltipFloat'

import img1 from '../../assets/img/my-vacancy-help-tooltip/1.jpg'

export default {
  name: 'VacancyHelpTooltips',
  components: {
    HelpTooltip,
    HelpFloat
  },
  props: {
    isFixed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      img1
    }
  },
  computed: {
    selector() {
      return {
        '_fixed': this.isFixed,
        '_open': this.isOpen
      }
    },
  },
  methods: {
    onToggle() {
      if (!this.isFixed) return

      if (this.isOpen) {
        unBlockScroll()
        this.isOpen = false
      } else {
        blockScroll()
        this.isOpen = true
      }
    },
  }
}
</script>

<style>

</style>
